module.exports = __webpack_public_path__ + "img/icon-fleche-bas-midnight.04d0a7a0.svg";